import { Directive, input, output } from '@angular/core';

/**
 * Catches a close a `dm-modal` or `dm-drawer` triggered itself — escape, the backdrop,
 * a swipe or the close icon all report back through `dmOpenChange` rather than closing
 * the overlay on their own, since every dialog here disables (or conditionally
 * disables) `canautoclose`.
 *
 * Bind `[lpOverlayDismissGuard]` to whatever local state still thinks the overlay is
 * open, so a `dmOpenChange` that follows a close this component already started does
 * not run the close path a second time. Left at its default of `true` where there is
 * no such state to guard against — the close path then runs on every
 * `dmOpenChange(false)`.
 */
@Directive({
  selector: '[lpOverlayDismissed]',
  host: {
    '(dmOpenChange)': 'onDmOpenChange($event)',
  },
})
export class OverlayDismissDirective {
  public readonly lpOverlayDismissGuard = input<boolean>(true);
  public readonly lpOverlayDismissed = output<void>();

  /**
   * @param {Event} event - The host's `dmOpenChange`, typed generically since a host
   * binding is not checked against the specific component it ends up attached to
   */
  protected onDmOpenChange(event: Event): void {
    const open = (event as CustomEvent<boolean>).detail;
    if (open || !this.lpOverlayDismissGuard()) {
      return;
    }
    this.lpOverlayDismissed.emit();
  }
}
